import { render, staticRenderFns } from "./maxHeightLimit.vue?vue&type=template&id=4868bc52&scoped=true&"
import script from "./maxHeightLimit.vue?vue&type=script&lang=js&"
export * from "./maxHeightLimit.vue?vue&type=script&lang=js&"
import style0 from "./maxHeightLimit.vue?vue&type=style&index=0&id=4868bc52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4868bc52",
  null
  
)

export default component.exports